import { Component, OnInit } from '@angular/core';
import {
  UntypedFormGroup, UntypedFormBuilder, Validators
} from '@angular/forms';

import { PasswordValidationService } from 'shared/services/password-validation.service';
import { StoreService } from 'shared/services/store.service';

@Component({
  selector: 'app-account-password',
  templateUrl: './account-password.component.html',
  styleUrls: ['./account-password.component.scss']
})
export class AccountPasswordComponent implements OnInit {
  form!: UntypedFormGroup;

  formReady = false;

  get passwordForm(): UntypedFormGroup {
    return this.form.controls.password as UntypedFormGroup;
  }

  constructor(
    private fb: UntypedFormBuilder,
    private storeService: StoreService,
    private passwordValidationService: PasswordValidationService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.setupForm();
  }

  setupForm(): void {
    this.storeService.setFormReady(this.formReady);

    this.form = this.fb.group({
      currentPassword: ['', Validators.required],
      password: this.fb.group({
        newPassword: ['', [
          Validators.required,
          this.passwordValidationService.atLeastOneNumber,
          this.passwordValidationService.atLeastOneLowerCase,
          this.passwordValidationService.atLeastOneUpperCase,
          this.passwordValidationService.atLeastOneSpecialCharacter,
          this.passwordValidationService.minLength,
          this.passwordValidationService.noWhiteSpace
        ]],
        confirmPassword: ['', Validators.required]
      }, { validators: this.passwordValidationService.checkPasswordMatch })
    });

    this.formReady = true;
    this.storeService.setFormReady(this.formReady);
  }
}
